import * as React from "react";
import { SvgIcon } from "@mui/material";
/** lucide */

export function AntFileZipOutlined(props) {
    return (
        <SvgIcon {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" width="1024" height="1024" viewBox="0 0 1024 1024">
                <path
                    fill="currentColor"
                    d="M296 392h64v64h-64zm0 190v160h128V582h-64v-62h-64zm80 48v64h-32v-64zm-16-302h64v64h-64zm-64-64h64v64h-64zm64 192h64v64h-64zm0-256h64v64h-64zm494.6 88.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7M790.2 326H602V137.8zm1.8 562H232V136h64v64h64v-64h174v216a42 42 0 0 0 42 42h216z"
                />
            </svg>
        </SvgIcon>
    );
}
